import React from 'react';
import { FaGithub } from 'react-icons/fa';
import { BsSun, BsMoon } from 'react-icons/bs';
import './Header.css';

const Header = ({ isDarkMode, onThemeToggle, onSymbolSubmit }) => {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && e.target.value.trim()) {
      onSymbolSubmit(e.target.value.trim());
      e.target.value = '';
    }
  };

  return (
    <header className={`header ${isDarkMode ? 'dark' : 'light'}`}>
      <div className="header-content"style={{maxWidth: '100%'}}>
        <div className="header-left">
          <h1>G-Charts</h1>
          <div className="search-container">
            <input
              type="text"
              placeholder="Enter symbol (e.g., BTCUSDT, AAPL), Press Enter"
              onKeyPress={handleKeyPress}
              className="symbol-input"
            />
          </div>
        </div>
        <div className="header-right">
          <button 
            className="theme-toggle" 
            onClick={onThemeToggle}
            title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
          >
            {isDarkMode ? <BsSun /> : <BsMoon />}
          </button>
          <a
            href="https://github.com/abdulhanan1000"
            target="_blank"
            rel="noopener noreferrer"
            className="github-link"
            title="View on GitHub"
          >
            <FaGithub />
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
